import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './index.css';

export interface IAvatarProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  character?: string;
  isRoundness?: boolean;
  isSmall?: boolean;
  url?: string;

  onClick?(): void;
}

export class Avatar extends React.PureComponent<IAvatarProps, {}> {
  public render() {
    const { character, className, isRoundness, isSmall, url } = this.props;

    if (url) {
      return (
        <img
          {...mergeStyles([
            className,
            styles['avatar'],
            isRoundness && styles['roundness'],
            isSmall && styles['small'],
          ])}
          onClick={this.props.onClick && this.props.onClick}
          src={url}
        />
      );
    }

    return (
      <div
        {...mergeStyles([
          className,
          styles['avatar'],
          styles['pseudo'],
          isRoundness && styles['roundness'],
          isSmall && styles['small'],
          !character && styles['userpic'],
        ])}
        onClick={this.props.onClick && this.props.onClick}
      >
        {character && <span className={styles['character']}>{character.toUpperCase()}</span>}
      </div>
    );
  }
}
